// vue实例
let newVue = {
  obj: null
}
const check = {}
//身份证号码识别
check.checkIdValidate = function (idnum){
  var  area={11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",21:"辽宁",22:"吉林",23:"黑龙江",
  31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",42:"湖北",
  43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏",
  61:"陕西",62:"甘肃",63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门",91:"国外"}
  var  idnum  =  idnum,Y,JYM;
  var  S,M;
  var  idnum_array  =  new  Array();
  idnum_array  =  idnum.split("");
  var  ereg;
  //地区检验
  if(area[parseInt(idnum.substr(0,2))]==null)  {
    newVue.obj.$Toast({
      content: '身份证地区非法!',
      type:'error',        
    });  
    return  false;
  }
  if  (parseInt(idnum.substr(6,4))  %  4  ==  0  ||  (parseInt(idnum.substr(6,4))  %  100  ==  0  &&  
  parseInt(idnum.substr(6,4))%4  ==  0  )){
  ereg=/^[1-9][0-9]{5}19[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}[0-9Xx]$/;//闰年出生日期的合法性正则表达式
  }  else  {
  ereg=/^[1-9][0-9]{5}19[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}[0-9Xx]$/;//平年出生日期的合法性正则表达式
  }
  if(ereg.test(idnum)){//测试出生日期的合法性
  //计算校验位
  S  =  (parseInt(idnum_array[0])  +  parseInt(idnum_array[10]))  *  7
  +  (parseInt(idnum_array[1])  +  parseInt(idnum_array[11]))  *  9
  +  (parseInt(idnum_array[2])  +  parseInt(idnum_array[12]))  *  10
  +  (parseInt(idnum_array[3])  +  parseInt(idnum_array[13]))  *  5
  +  (parseInt(idnum_array[4])  +  parseInt(idnum_array[14]))  *  8
  +  (parseInt(idnum_array[5])  +  parseInt(idnum_array[15]))  *  4
  +  (parseInt(idnum_array[6])  +  parseInt(idnum_array[16]))  *  2
  +  parseInt(idnum_array[7])  *  1  
  +  parseInt(idnum_array[8])  *  6
  +  parseInt(idnum_array[9])  *  3  ;
  Y  =  S  %  11;
  M  =  "F";
  JYM  =  "10X98765432";
  M  =  JYM.substr(Y,1);//判断校验位
  if(M  !=  idnum_array[17].toUpperCase())  {
    newVue.obj.$Toast({
      content: '身份证号码校验错误!',
      type:'error',        
    });
    return  false;
  }  //检测ID的校验位
  }else  {
    newVue.obj.$Toast({
      content: '身份证号码出生日期超出范围或含有非法字符!',
      type:'error',        
    });  
    return  false;
  }
  return  true;
}

// 密码
check.checkPwValidate = function (password){
  let regPw = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/
  if (!regPw.test(password)) {        
    newVue.obj.$Toast({
      content: '请输入数字和字母，且密码长度6-20位',
      type:'error',        
    });
    return false;
  }
  return  true;
}

// 密码
check.checkEmailValidate = function (email){
  let reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
  if (!reg.test(email)) {        
    newVue.obj.$Toast({
      content: '请输入合法的邮箱',
      type:'error',        
    });
    return false;
  }
  return  true;
}

export { newVue, check }